import React from 'react';

const styles = {
  card: {
    background: '#fff',
    borderRadius: '12px',
    padding: '40px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    textAlign: 'center',
  },
  icon: {
    fontSize: '64px',
    marginBottom: '16px',
  },
  heading: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#276749',
    marginBottom: '12px',
  },
  message: {
    fontSize: '16px',
    color: '#4a5568',
    marginBottom: '8px',
  },
  detail: {
    fontSize: '14px',
    color: '#718096',
    marginBottom: '24px',
  },
  id: {
    fontFamily: 'monospace',
    background: '#f7fafc',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '14px',
  },
  button: {
    padding: '14px 32px',
    background: '#9C3D97',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    marginTop: '16px',
  },
};

export default function ConfirmationPage({ data, onSubmitAnother }) {
  // A single, identical confirmation for every submission. Previously the
  // graded vs non-graded paths showed different copy, and the "now being
  // graded / results in the admin portal" line both revealed whether a case
  // was graded (which VAs must not know) and was only relevant to admins
  // (Monday #12035823202).
  return (
    <div style={styles.card}>
      <div style={styles.icon}>&#10004;</div>
      <h1 style={styles.heading}>Submission Received</h1>
      <p style={styles.message}>Your SOAP note has been submitted successfully.</p>
      <p style={styles.detail}>
        Submission ID: <span style={styles.id}>{data?.submission_id || 'N/A'}</span>
      </p>
      <button style={styles.button} onClick={onSubmitAnother}>
        Submit Another SOAP Note
      </button>
    </div>
  );
}
